import config from '@/config';
import Config from '@/plugins/config';
import Logger from '@/plugins/logger';

import FocusVisiblePlugin from '@/plugins/focusVisible';
import VisibleDirective from '@/plugins/visible';
import DatadogPlugin from '@/plugins/datadog';

// Common plugins should be installed here
export default {
  install(app) {
    app.use(Config);
    app.use(FocusVisiblePlugin);
    app.use(VisibleDirective);

    app.use(Logger, { enabled: !!config.logLevel, logLevel: config.logLevel });

    if (config.datadogEnabled) {
      app.use(DatadogPlugin);
    }
  },
};
